module.exports = __webpack_public_path__ + "static/media/user-robot.b335f6de.svg";